import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import {connect} from "react-redux";
import { patchCatalogDescription } from 'redux/catalog/actions';

import onClickOutside from "react-onclickoutside";

import InputField from 'components/elements/InputField';

import { fixURL } from 'utils/fixURL';

import './CatalogUrl.css';

const ENTER_KEY = 13;


class CatalogUrl extends Component {
  static propTypes = {
    patchCatalogDescription: PropTypes.func.isRequired,
    catalogDescription: PropTypes.object,
    patchCatalogDescriptionError: PropTypes.object,
    location: PropTypes.object.isRequired,
  };

  static defaultProps = {
    catalogDescription: null,
    patchCatalogDescriptionError: null,
  };

  state = {
    initialValue: null,
    currentValue: null,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.catalogDescription) {
      this.setState({
        initialValue: this.props.catalogDescription.url,
        currentValue: this.props.catalogDescription.url,
      });
    }

    if (this.props.location) {
      const isCatalogUrlFocused = this.useQuery(this.props.location.search);
      if (isCatalogUrlFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.catalogDescription &&
      (prevProps.catalogDescription.url || prevProps.catalogDescription.url === '') &&
      prevProps.catalogDescription.url !== this.props.catalogDescription.url
    ) {
      this.setState({ currentValue: this.props.catalogDescription.url });
    }

    if (prevProps.location !== this.props.location) {
      const isCatalogUrlFocused = this.useQuery(this.props.location.search);
      if (isCatalogUrlFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  inputEditFieldRef = createRef();

  changeCatalogUrl = () => {
    const { initialValue, currentValue } = this.state;

    if (currentValue !== initialValue) {
      const form = new FormData();

      if (currentValue === '') {
        this.setState({ initialValue: currentValue});
        form.append('url', currentValue);
      } else {
        this.setState({ initialValue: fixURL(currentValue)});
        form.append('url', fixURL(currentValue));
      }

      this.props.patchCatalogDescription(
        this.props.catalogDescription.id,
        form,
      );
    }
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this.changeCatalogUrl();
    }
  };

  useQuery = param => {
    return new URLSearchParams(param).get('focus');
  };

  handleClickOutside = () => {
    this.changeCatalogUrl();
  };

  executeValidation = () => {
    const { patchCatalogDescriptionError } = this.props;

    if (patchCatalogDescriptionError && patchCatalogDescriptionError.url) {
      return patchCatalogDescriptionError.url;
    }

    return null;
  };

  render() {
    const { catalogDescription } = this.props;
    const { currentValue } = this.state;

    if (!catalogDescription) return null;

    return (
      <Translation>
        {(t) => (
          <div className="catalog-url__component">
            <div className="input-wrapper">
              <InputField
                value={currentValue}
                placeholder={t("Add existing store link")}
                onChange={(e) => {
                  e.preventDefault();
                  this.setState({ currentValue: e.target.value });
                }}
                customRef={this.inputEditFieldRef}
                error={this.executeValidation() && {text: this.executeValidation()}}
              />
            </div>
            <div className="subtext">{t("Store Link")}</div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    catalogDescription: state.catalogReducer.catalogDescription,
    patchCatalogDescriptionError: state.catalogReducer.patchCatalogDescriptionError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCatalogDescription,
  },
)(onClickOutside(CatalogUrl));
